import { Modal, ModalActionTypes, ModalActionNames } from './types';

const initialState: Modal = {
  open: false,
  message: '',
  accept: undefined,
  acceptButtonText: undefined,
  cancel: undefined,
  cancelButtonText: undefined,
};

export const modalReducer = (state: Modal = initialState, action: ModalActionTypes): Modal => {
  switch (action.type) {
    case ModalActionNames.OPEN_MODAL: {
      return { ...action.payload };
    }
    case ModalActionNames.CLOSE_MODAL: {
      return initialState;
    }
    default:
      return state;
  }
};
